'use client';

import { c as _c } from "react/compiler-runtime";
import { TileCard } from './TileCard';
import { TileVideo } from './ui/tile-video';
interface InspirationTileProps {
  className?: string;
  onClick?: () => void;
}
export default function InspirationTile(t0) {
  const $ = _c(4);
  const {
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TileVideo src="/images/craft/inspiration-optimized.mp4" posterSrc="/images/craft/inspiration-poster.jpg" title="Vision Board" className="size-full object-cover transition-transform group-hover:scale-105" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== onClick) {
    t2 = <TileCard href="/inspiration" title="Vision Board" description="People & ideas that inspire me" className={className} onClick={onClick}>{t1}</TileCard>;
    $[1] = className;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}